import React, { useEffect } from "react";
import CalendarConfirmationModal from "../ConfirmationModal/CalendarConfirmationModal";
import useCalendarModal from "./hooks/useCalendarModal";
import CalendarFlow from "./CalendarFlow";

interface IProps {
  exerciseName: string;
  zone: number;
}

const CalendarModal: React.FC<IProps> = ({ exerciseName }: IProps) => {
  const {
    selectionState,
    handleTimeSelection,
    handleDateSelect,
    exercise,
    selectedDate,
    listaDat,
    soldOutDates,
    alerts,
    isConfirmationModalOpen,
    toggleConfirmationModal,
    joinToExerciseByPass,
    refreshCapacityAfterAddTicket,
    modifiedAlwaysShowHoursToChoose,
    hoursLoading,
    daysLoaded,
    init,
  } = useCalendarModal(exerciseName);

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <CalendarFlow
        selectedDate={selectedDate}
        exerciseName={exerciseName}
        listaDat={listaDat}
        soldOutDates={soldOutDates}
        daysLoaded={daysLoaded}
        exercise={exercise}
        alerts={alerts}
        selectionState={selectionState}
        onDateSelect={handleDateSelect}
        onTimeSelect={handleTimeSelection}
        joinToExerciseByPass={joinToExerciseByPass}
        refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
        showHoursToChoose={modifiedAlwaysShowHoursToChoose}
        hoursLoading={hoursLoading}
      />

      <CalendarConfirmationModal isOpen={isConfirmationModalOpen} onClose={() => toggleConfirmationModal(false)} />
    </>
  );
};

export default CalendarModal;
